import { AgentIcon } from "~/business";
import { expectNever } from "~/utils";
import { XBeneGesseritSvg } from "./svg";
import { XCityActionSvg } from "./svg";
import { XEmperorSvg } from "./svg";
import { XFremenSvg } from "./svg";
import { XGuildSvg } from "./svg";
import { XLandsraadActionSvg } from "./svg";
import { XSpiceActionSvg } from "./svg";

export const XAgentIcon = ({
  agentIcon,
  width,
}: {
  agentIcon: AgentIcon;
  width: number;
}) => {
  const Builder = getBuilder(agentIcon);
  return <Builder width={width} />;
};

const getBuilder = (agentIcon: AgentIcon) => {
  switch (agentIcon) {
    case AgentIcon.City:
      return XCityActionSvg;
    case AgentIcon.Landsraad:
      return XLandsraadActionSvg;
    case AgentIcon.SpiceTrade:
      return XSpiceActionSvg;
    case AgentIcon.Emperor:
      return XEmperorSvg;
    case AgentIcon.SpacingGuild:
      return XGuildSvg;
    case AgentIcon.BeneGesserit:
      return XBeneGesseritSvg;
    case AgentIcon.Fremen:
      return XFremenSvg;
    default:
      expectNever(agentIcon);
      throw new Error();
  }
};
